const BackCrossSvg = ( { className } ) => {
	return (
		<svg
			width="100%"
			viewBox="0 0 32 32"
			className={className}>
			<path
				fill="currentColor"
				// eslint-disable-next-line max-len
				d="M0 27.1929L11.5109 16L0 4.80707L4.94364 0L16.3614 11.1024L26.877 0.0908203L32.0002 4.71668L21.3085 15.9128L21.3982 16L21.3083 16.0874L32.0002 27.2837L26.877 31.9096L16.3612 20.8978L4.94364 32L0 27.1929Z"
			/>
		</svg>

	);
};
export default BackCrossSvg;
